module.exports = __webpack_public_path__ + "02_glasses_red.ace1e71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/02_glasses_red.png
// module id = XOTo
// module chunks = 0